let activeSessionChatId: string | null = null;

const getActiveSessionChatId = (): string | null => activeSessionChatId;

const setActiveSessionChatId = (chatId: string): void => {
	activeSessionChatId = chatId;
};

const clearActiveSessionChatId = (): void => {
	activeSessionChatId = null;
};

const fernieActiveSession = {
	clearActiveSessionChatId,
	getActiveSessionChatId,
	setActiveSessionChatId
};

export default fernieActiveSession;
